import { getCognitoConfig } from './config';
import { buildAuthorizeUrl } from './login';
import { clearCognitoSession } from './session';
import { stopTokenRefreshScheduler } from './refresh';

// In-app login page fallback when the Hosted UI logout request cannot be built.
const LOGIN_PATH = '/loginchoice';

/** Build the Cognito logout URL: sign out, then show the login page via authorize params. */
export const buildLogoutUrl = async () => {
  const { domain } = getCognitoConfig();
  const authorizeUrl = await buildAuthorizeUrl();
  const query = authorizeUrl.slice(authorizeUrl.indexOf('?') + 1);
  return `${domain}/logout?${query}`;
};

/** Clear the local Cognito session and redirect to the Hosted UI logout endpoint. */
export const initiateCognitoLogout = async () => {
  stopTokenRefreshScheduler();
  clearCognitoSession();

  try {
    const url = await buildLogoutUrl();
    window.location.assign(url);
  } catch (err) {
    // Avoid sending a malformed request to the Hosted UI; fall back to the in-app login page.
    // eslint-disable-next-line no-console
    console.error('[cognito] unable to build logout URL:', err);
    window.location.assign(LOGIN_PATH);
  }
};

export default initiateCognitoLogout;
